import { noTransformerError, PropertyInfos, TypeInfos } from "./index";
export { PropertyInfos, TypeInfos } from "./index";

/**
 * This function is used in TypedProxy decorators, it exposes an object where each property is retrieved using getValue function.
 * The getValue function is called on first access and the results are kept in target._propertyKey__cache
 */
export function decorateProxyWithCachedGetValue<T>(
    getValue: (target: T, propertyKey: string, proxiedPropertyName: string, proxiedPropertyInfos: PropertyInfos) => unknown,
    typeInfos?: TypeInfos): (classPrototype: unknown, propertyKey: string) => void {
    if (!typeInfos) {
        noTransformerError("decorateProxyWithCachedGetValue");
        return () => { };// unreachable - noTransformerError throws an error
    }
    if (!typeInfos.properties) {
        console.error("There is no property for Typed decorator");
    }
    return (classPrototype: unknown, propertyKey: string): void => {
        const cacheProperty = "_" + propertyKey + "__cache";
        const getter = function (this: T): number | undefined {
            let cache = (this as any)[cacheProperty];
            if (!cache) {
                // fill cache with getValue for each property
                cache = {};
                (this as any)[cacheProperty] = cache;
                if (typeInfos.properties) {
                    for (const pn in typeInfos.properties) {
                        const proxiedPropertyName = String(pn);
                        const proxiedPropertyInfos = typeInfos.properties[pn];
                        try {
                            cache[proxiedPropertyName] = getValue(this, propertyKey, proxiedPropertyName, proxiedPropertyInfos);
                        } catch (err) {
                            if (!proxiedPropertyInfos.isOptional) {
                                console.error("Proxy acess to " + propertyKey + "." + proxiedPropertyName + " failed", err);
                            }
                        }
                    }
                }
            }
            return (this as any)[cacheProperty];
        };
        Object.defineProperty(classPrototype, propertyKey, {
            get: getter
        });
    };
}
